<template>
  <v-btn size="x-small" class="ml--2 text-3.5">
    <span class="mr-1">{{ text }}</span>
    <Icon name="ic:baseline-expand-more" />
    <v-menu
      activator="parent"
      location="bottom"
      transition="slide-y-transition"
      offset="15"
    >
      <v-card class="py-2">
        <v-item-group
          v-model="selection"
          :disabled="disabled"
          :multiple="multiple"
          :max="max"
        >
          <div v-for="item in items_" :key="item.value">
            <v-item v-slot="{ isSelected, toggle }" :value="item.value">
              <v-list-item
                @click="toggle"
                :active="isSelected"
                active-color="primary"
                class="pl-2"
              >
                <template #prepend>
                  <span class="mr-2 flex-align">
                    <v-icon :class="{ 'opacity-0': !isSelected }" size="20"
                      >check</v-icon
                    >
                  </span>
                </template>
                <template #title>
                  <div>{{ item.title }}</div>
                </template>
              </v-list-item>
            </v-item>
          </div>
        </v-item-group>
      </v-card>
    </v-menu>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { first, get, isObject } from "lodash";
import type { PropType } from "vue";

export default defineComponent({
  props: {
    modelValue: {},
    items: { type: Array as PropType<any[]>, required: true },
    emptyText: { type: String, default: "Select option" },
    itemTitle: { type: String, default: "title" },
    itemValue: { type: String, default: "value" },
    multiple: { type: Boolean, default: false },
    mandatory: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    max: { type: Number },
  },
  setup(props, ctx) {
    const getTitle = (item: any) => {
      return isObject(item) ? get(item, props.itemTitle) : item;
    };
    const getValue = (item: any) => {
      return isObject(item) ? get(item, props.itemValue) : item;
    };

    const setMandatoryDefault = once(() => {
      if (props.mandatory && !props.modelValue) {
        const item = first(props.items);
        const value = getValue(item);
        ctx.emit("update:modelValue", value);
      }
    });

    const items_ = computed(() => {
      return props.items.map((item) => ({
        title: getTitle(item),
        value: getValue(item),
      }));
    });

    const text = computed(() => {
      if (props.modelValue) {
        const item = props.items.find((x) => getValue(x) == props.modelValue);
        return getTitle(item);
      }

      return props.emptyText;
    });

    onMounted(() => nextTick(setMandatoryDefault));

    return {
      items_,
      text,
    };
  },
  computed: {
    selection: {
      set(value: any) {
        this.$emit("update:modelValue", value);
      },
      get() {
        return this.modelValue;
      },
    },
  },
});
</script>
